import { render, staticRenderFns } from "./FooterInitial.vue?vue&type=template&id=21b89964&scoped=true&"
import script from "./FooterInitial.vue?vue&type=script&lang=js&"
export * from "./FooterInitial.vue?vue&type=script&lang=js&"
import style0 from "./FooterInitial.vue?vue&type=style&index=0&id=21b89964&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b89964",
  null
  
)

export default component.exports